<template>
  <div class="chat-comment" v-if="page.vis" @click="close">
    <div :class="['chat-comment__panel', !page.isMobile ? 'panel1' : 'panel2']" @click.stop="(e) => {}">
      <comment-form
        :styleConfig="styleConfig"
        :commentStyle="commentStyle"
        :orgId="orgId"
        :showType="props.showType"
        :chatId="chatId"
        :commentType="page.commentType"
        @close="close"
      />
    </div>
  </div>
</template>
<script setup>
import CommentForm from '@/components/service/commentForm.vue'
import { reactive, defineExpose, defineProps, onMounted, onBeforeUnmount, computed } from 'vue'
import { isMobile } from '@/utils/index'
const props = defineProps({
  styleConfig: { type: Object, default: () => {} },
  orgId: { type: String },
  chatId: { type: String },
  showType: { type: Number, default: 1 }
})
// 在线客服评价样式
const commentStyle = computed(() => {
  return props.styleConfig?.commentStyle || {}
})
const page = reactive({
  vis: false,
  commentType: 0,
  isMobile: isMobile()
})
const open = (cType = 0) => {
  page.vis = true
  page.commentType = cType
}
const close = () => {
  page.vis = false
}
const handleResize = () => {
  page.isMobile = isMobile()
}
onMounted(() => {
  window.addEventListener('resize', handleResize)
})
onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize)
})
defineExpose({
  open
})
</script>
<style scoped lang="less">
.chat-comment {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  left: 0;
  &__panel {
    background-color: #ffffff;
    position: absolute;
    &.panel1 {
      width: 300px;
      top: 25%;
      left: calc(50% - 150px);
      border-radius: 10px;
    }
    &.panel2 {
      bottom: 0;
      width: 100%;
      border-radius: 10px 10px 0 0;
    }
  }
}
</style>
